import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { TypeIndicateur } from "../../types/typeIndicateurs";

interface UseGetTypeIndicateursOptions
  extends Omit<UseQueryOptions<TypeIndicateur[], Error>, "queryKey" | "queryFn"> {}

export const useGetTypeIndicateurs = (options: UseGetTypeIndicateursOptions = {}) => {
  return useQuery<TypeIndicateur[], Error>({
    queryKey: ["typeIndicateurs"],
    queryFn: async () => {
      console.log("[useGetTypeIndicateurs] Fetching type indicateurs...");

      // Backend exposes ChampMetier via /iam/champs-metier/.
      // We map it to the (legacy) TypeIndicateur shape used by the UI.
      const response = await fetchClient<any[]>("/iam/champs-metier/");

      if (response.error) {
        const errorMessage =
          response.error.detail ||
          response.error.non_field_errors?.[0] ||
          "Failed to fetch type indicateurs";
        throw new Error(errorMessage);
      }

      if (!response.data) {
        console.warn("[useGetTypeIndicateurs] No data received");
        return [];
      }

      const data: TypeIndicateur[] = (response.data || []).map((item: any) => ({
        id: item.id,
        code: item.code,
        libelle: item.libelle,
        unite_default: item.unite_defaut ?? "",
        poste: item.poste,
      }));

      console.log("[useGetTypeIndicateurs] Successfully fetched", data.length, "type indicateurs");
      return data;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes since these don't change often
    ...options,
  });
};
